// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getAuth } from 'firebase/auth';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyDgWd-GWbsLBT2yYcUV4dT7AwZN4Qt7FzI",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "reebe-69943.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "reebe-69943",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "reebe-69943.appspot.com",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "421629201198",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:421629201198:web:fdd20213005bfc080c88bf"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
const db = getFirestore(app);

// Initialize Auth
const auth = getAuth();

// Initialize Functions
const functions = getFunctions(app);

export { db, auth, functions };